export default __webpack_public_path__ + "static/media/deposit-icon.51489773.webp";